var map = {
	"./Fintechhighlighted.png": "494c",
	"./asocupa-2023.png": "4696",
	"./banner-antifraude.jpg": "0ba7",
	"./banner-controlinterno.jpg": "e443",
	"./banner-cumplimiento.jpg": "e7bd",
	"./banner-industria.jpg": "a271",
	"./banner-portaletico.jpg": "0fad",
	"./banner-prevencion.jpg": "c85d",
	"./canaldedenuncias.png": "a146",
	"./capacitacion.png": "058c",
	"./cep_.png": "ccf5",
	"./ceptinel-present-financial-services-forum.png": "37dd",
	"./ceptinel-top-five.png": "77e7",
	"./congreso-colombia.png": "e01e",
	"./diario-financiero.png": "cfca",
	"./estrategia_diario.png": "0437",
	"./goglobal1.png": "f9b1",
	"./hemispheric-congress.png": "e5c9",
	"./innova-startup-week-2023 copia.png": "333a",
	"./innova-startup-week-2023.png": "b0a4",
	"./insurtech-latam-forum-2023.png": "24cb",
	"./mapa-regtech-mundo.png": "5ec4",
	"./market-market.png": "791e",
	"./mckinsey.png": "8e39",
	"./media-presence.png": "ca8e",
	"./mexico-business-round-2023 copia.png": "1896",
	"./mexico-business-round-2023.png": "394c",
	"./new-logo.png": "1dad",
	"./partnership-cab.png": "4d83",
	"./partnership-cyberventures.png": "b7c6",
	"./portalminero.png": "0450",
	"./radio-bio-bio.png": "8f0f",
	"./research-market.png": "cce9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9179";